<template>
    <div class="main-stat-container">
        <div class="main-stat">
            <div>
                <span class="icon">
                    <i class="fa fa-calendar" />
                </span>
                <span>{{ translate("page.events.event_date") }}</span>
            </div>

            <div>
                <LocalizedEventDate :event-date="basicEventData?.eventDate" :timezone="basicEventData?.timezone ?? 'UTC'" />
            </div>
        </div>
        <div class="main-stat" v-if="mainStats?.registeredCompetitors !== null && mainStats?.registeredCompetitors !== undefined">
            <div>
                <span class="icon">
                    <i class="fa fa-users" />
                </span>
                <span>
                    {{ translate("page.admin_welcome.registered_competitors") }}
                </span>
            </div>
            <div>{{ mainStats.registeredCompetitors }}</div>
        </div>
        <div class="main-stat" v-if="mainStats?.confirmedPayments !== null && mainStats?.confirmedPayments !== undefined">
            <div>
                <span class="icon">
                    <i class="fa fa-money-check-alt" />
                </span>
                <span>{{ translate("page.admin_welcome.confirmed_payments") }}</span>
            </div>

            <div>{{ mainStats.confirmedPayments }}</div>
        </div>
        <div class="main-stat" v-if="mainStats?.totalVerifications !== null && mainStats?.totalVerifications !== undefined">
            <div>
                <span class="icon">
                    <i class="fa fa-user-check" />
                </span>
                <span>
                    {{ translate("page.admin_welcome.total_verifications") }}
                </span>
            </div>

            <div>{{ mainStats.totalVerifications }}</div>
        </div>

        <MaskedField v-if="mainStats?.eventCost" class="main-stat tag-event-cost" @click="openEventCostModal">
            <div>
                <span class="icon">
                    <i class="fa fa-money-bill-wave" />
                </span>
                <span>{{ translate("page.admin_welcome.event_cost") }}</span>
            </div>

            <div>
                <a>{{ mainStats?.eventCost }}</a>
            </div>
        </MaskedField>
    </div>
</template>

<script setup lang="ts">
    import LocalizedEventDate from "../Common/LocalizedEventDate.vue";
    import { BasicEventData, MainStats } from "../Api/adminEventSummaryApi";
    import { eventBus, ON_EVENT_COST_BREAKDOWN_MODAL_OPEN } from "./eventBus";
    import { translate } from "../Common/translations";
    import MaskedField from "../Common/MaskedField.vue";

    defineProps<{
        basicEventData: BasicEventData | undefined | null;
        mainStats: MainStats | undefined | null;
    }>();

    function openEventCostModal() {
        eventBus.$emit(ON_EVENT_COST_BREAKDOWN_MODAL_OPEN);
    }
</script>

<style scoped></style>
